import { createAsyncThunk } from '@reduxjs/toolkit';

import { CardService } from '../../service/card.service';
import { toastrError } from '../../utils/toastr-error';

import { ICardResponse, ICardSlug } from './card.interface';

export const fetchCardItem = createAsyncThunk<ICardResponse, ICardSlug>(
  'catalog-item/fetch-one',
  async ({ slug }, thunkAPI) => {
    try {
      const response = await CardService.getOne(slug);
      return response.data;
    } catch (error) {
      toastrError(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
